import { render, staticRenderFns } from "./examine.vue?vue&type=template&id=8f7277c2&scoped=true&"
import script from "./examine.vue?vue&type=script&lang=js&"
export * from "./examine.vue?vue&type=script&lang=js&"
import style0 from "./examine.vue?vue&type=style&index=0&id=8f7277c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7277c2",
  null
  
)

export default component.exports